import { Molecule, wrap, Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';
import { Icon, Text } from 'atoms';
import { Mr1 } from 'wrappers';
import { SecondaryTextXs, SecondaryTextLg } from 'atoms';

const template = styled.div`
  ${({ displayState }) => css`
        margin-left: 0.5rem;
        background: #FFF;
        border: 1px solid rgb(227, 227, 227);
        box-shadow: 0px 1px 2px rgba(0,0,0,0.08);
        border-radius: 20px;
        display: flex;
        position: relative;
        overflow: auto;
        flex-direction: column;
        justify-content: space-between;
        padding: 15px 15px;
        height: 132px;
        width: ${displayState?.width ?? "148px"};
        z-index: 1;
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
        component: wrap(SecondaryTextXs, Wrapper(styled.div`font-weight: 600;`)),
        name: 'TopText',
        renderIf: ({ topText }) => !!topText,
        displayValue: ({ topText }) => topText,
        displayState: ({ }) => ({ fontWeight: 600 })
    },
    {
        component: SecondaryTextLg,
        name: 'MainText',
        renderIf: ({ mainText }) => !!mainText,
        displayValue: ({ mainText }) => mainText
    },
    {
        component: wrap(SecondaryTextXs, Wrapper(styled.div`font-weight: 600;`)),
        name: 'BottomText',
        renderIf: ({ bottomText }) => !!bottomText,
        displayValue: ({ bottomText }) => bottomText,
        displayState: ({ }) => ({ fontWeight: 600 })
    },
  ]
})
